/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-12-24T10:10:30.879
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveKhmDemandApply,
	getKhmDemandApplyCreateInit,
	getKhmDemandApplyEditInit,
	getKhmDemandApplyView,
	deleteKhmDemandApply,
	startWorkflow
} from '@api/rentmanage/KhmDemandApply';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getKhmDemandApplyCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getKhmDemandApplyCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getKhmDemandApplyEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getKhmDemandApplyEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		startWorkflow({}, KhmDemandApply) {
			return new Promise((resolve, reject) => {
				startWorkflow(KhmDemandApply)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		saveKhmDemandApply({}, KhmDemandApply) {
			return new Promise((resolve, reject) => {
				saveKhmDemandApply(KhmDemandApply)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getKhmDemandApplyView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getKhmDemandApplyView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteKhmDemandApply({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteKhmDemandApply({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
